<script setup>
import { layoutConfig } from '@layouts'
import { useLayoutConfigStore } from '@layouts/stores/config'
import {
  getComputedNavLinkToProp,
  getDynamicI18nProps,
  isNavLinkActive,
} from '@layouts/utils'

const props = defineProps({
  item: {
    type: null,
    required: true,
  },
})

const configStore = useLayoutConfigStore()
const hideTitleAndBadge = configStore.isVerticalNavMini()
const router = useRouter()

const linkComponent = computed(() => {
  if (!props.item.to) return 'a'
  
  // Eğer route name ile tanımlıysa ve route mevcut değilse span yap (Hata önleme)
  if (typeof props.item.to === 'object' && props.item.to.name) {
    if (!router.hasRoute(props.item.to.name)) {
      return 'div' // Link olma özelliğini kaldır
    }
  }
  
  return 'RouterLink'
})
</script>

<template>
  <li class="nav-link" :class="{ disabled: item.disable }">
    <Component :is="linkComponent"
               v-bind="linkComponent === 'RouterLink' || linkComponent === 'a' ? getComputedNavLinkToProp(item) : {}"
               :class="{
                 'router-link-active router-link-exact-active': linkComponent === 'RouterLink' && isNavLinkActive(
                   item,
                   $router,
                 ),
               }"
    >
      <Component :is="layoutConfig.app.iconRenderer || 'div'"
                 v-bind="item.icon && typeof item.icon === 'object' && item.icon !== null
                   ? item.icon
                   : layoutConfig.verticalNav.defaultNavItemIconProps || {}
                 "
                 class="nav-item-icon"
      />
      <TransitionGroup name="transition-slide-x">
        <!-- 👉 Title -->
        <Component :is="layoutConfig.app.i18n.enable ? 'i18n-t' : 'span'"
                   v-show="!hideTitleAndBadge"
                   key="title"
                   class="nav-item-title"
                   v-bind="getDynamicI18nProps(item.title, 'span')"
        >
          {{ item.title }}
        </Component>

        <!-- 👉 Badge -->
        <Component :is="layoutConfig.app.i18n.enable ? 'i18n-t' : 'span'"
                   v-if="item.badgeContent"
                   v-show="!hideTitleAndBadge"
                   key="badge"
                   class="nav-item-badge"
                   :class="item.badgeClass"
                   v-bind="getDynamicI18nProps(item.badgeContent, 'span')"
        >
          {{ item.badgeContent }}
        </Component>
      </TransitionGroup>
    </Component>
  </li>
</template>

<style lang="scss">
.layout-vertical-nav {
  .nav-link a {
    display: flex;
    align-items: center;
  }
}
</style>
